import { Component, inject, OnInit } from '@angular/core';
import { ConsoleService } from 'services/console.service';
import { mergeMap } from 'rxjs/operators';
import { PATHS } from 'models/bary-paths.model';
import { Router } from '@angular/router';
import { InsuranceItemService } from '../../../../services/insurance-item.service';
import { Transporter } from '../../../../models/transporter.model';
import { Transport } from '../../../../models/transport.model';
import { BasketService } from '../../../../services/basket.service';
import { TaskExtendedService } from '../../../../services/task-extended.service';
import { EstimateService } from '../../../../services/estimate.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { CurrentDataService } from '../../../../services/current-data-service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'jhi-bary-console',
  templateUrl: './bary-console.component.html',
  styleUrls: ['./bary-console.component.scss'],
})
export class BaryConsoleComponent implements OnInit {
  readonly #consoleService = inject(ConsoleService);
  readonly #currentDataService = inject(CurrentDataService);
  readonly #basketService = inject(BasketService);
  readonly #insuranceItemService = inject(InsuranceItemService);
  readonly #router = inject(Router);
  readonly #taskService = inject(TaskExtendedService);
  readonly #estimateService = inject(EstimateService);
  readonly #spinnerService = inject(NgxSpinnerService);
  readonly #http = inject(HttpClient);
  readonly #datePipe = inject(DatePipe);

  protected isLocal = !environment.production;

  private isHide = false;
  private transporter!: Transporter;

  public ngOnInit(): void {
    this.#currentDataService.getCurrentTransporter().subscribe(transporter => (this.transporter = transporter!));
    // on initialise fermé
    this.toggleHide();
  }

  public toggleHide(): void {
    if (this.isHide) {
      document.getElementById('console')!.style.left = '0';
      document.getElementById('console')!.style.bottom = '0';
      this.isHide = false;
    } else {
      document.getElementById('console')!.style.left = '-460px';
      document.getElementById('console')!.style.bottom = '-160px';
      this.isHide = true;
    }
  }

  public pushLastTask(): void {
    this.#taskService.pushLast().subscribe();
  }

  public addGeneralTransportToBasket(): void {
    this.addTransportToBasket(this.#consoleService.getGeneralTransport());
  }

  public addAdrTransportToBasket(): void {
    this.addTransportToBasket(this.#consoleService.getAdrTransport());
  }

  public addTransportToBasket(transport: Transport): void {
    this.#spinnerService.show().then();
    this.#estimateService
      .estimatePricing(transport)
      .pipe(
        mergeMap(offer => {
          transport.offerId = offer.body![0].id;
          return this.#insuranceItemService.findAllByOfferId(offer.body![0].id);
        }),
        mergeMap(insurance => {
          transport.insuranceItem = insurance.body![0];
          transport.insuranceItem.quotationRequired = false;
          transport.itemsNature = insurance.body![0].itemsNature;
          return this.#basketService.addTransportToBasket(transport);
        })
      )
      .subscribe(() => {
        this.#spinnerService.hide().then();
        this.#router.navigateByUrl(PATHS.ORDER_BASKET.path).then();
      });
  }

  public billRobot(date: string): void {
    const targetDate = new Date();
    switch (date) {
      case 'today':
        break;
      case 'week':
        targetDate.setDate(targetDate.getDate() + (7 - targetDate.getDay()));
        break;
      case 'month':
        targetDate.setMonth(targetDate.getMonth() + 1);
        targetDate.setDate(0);
        break;
    }
    const formattedDate = this.#datePipe.transform(targetDate, 'dd.MM.yyyy');
    this.#http
      .get(`${environment.urlApi}api/scheduler/bill/robot?desiredExecutionDate=${formattedDate}&transporterIds=${this.transporter.id}`, { responseType: 'text' })
      .subscribe();
  }
}
